import { TAppState } from '../types/appState';

export const chatbotSelector = (state: TAppState) => state.chatbot;
